import * as constants from '../constants/CONSTANT';

const OrderProductApi = {
  async searchProducts({ currency, search = '', limit = 25, offset = 0 }) {
    const token = localStorage.getItem('token');

    const params = new URLSearchParams({
      currency: currency || '',
      search,
      limit: String(limit),
      offset: String(offset),
    });

    const response = await fetch(
      `${constants.API_BASE_URL}/api/orderproduct/search?${params.toString()}`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
      }
    );

    return await response.json();
  },

  async createOrderProducts({ orderId, items, deletedIds = [] }) {
    const token = localStorage.getItem('token');

    const response = await fetch(
      `${constants.API_BASE_URL}/api/orderproduct`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
        body: JSON.stringify({
          orderId,
          items,
          deletedIds,
        }),
      }
    );

    return await response.json();
  },
};

export default OrderProductApi;
